import {Route} from "react-router-dom";
import React from "react";
import AceSelectorContainer from "../components/AceSelectorContainer";
import AddCompaniesFromAceAlerts from "../../components/Register/addCompanyFromAceAlerts";

export const ACE_SELECTION_ROUTE = (<Route path="/ACEalerts" exact component={AceSelectorContainer}/>);
export const ACE_ADD_COMPANIES_ROUTE = (<Route path="/addCompany" exact component={AddCompaniesFromAceAlerts} />);


// WEBPACK FOOTER //
// ./src/ace/routes/routes.js